import { createSlice } from '@reduxjs/toolkit'
import { apiSlice } from './api/apiSlice'

const initialState = {
  data: {
    sessionDateParsed: 0,
    propertySearch: {
      saveEnabled: true,
    },
    fileUploadSearch: {
      errors: 0,
      mortgagesAdded: 0,
      duplicateMortgages: 0,
      awaitingInitialSweep: true,
    },
    modalDisplays: {
      welcome: false,
      leadActions: false,
      mortgageActions: false,
    },
    currentUserActionsRole: '',
    repositoryPageSize: 20,
    repositoryPage: 0,
    duplicates: [{}, []],
    auth: {
      ipError: false,
      appError: false,
      ipAcquired: false,
      loginFailed: false,
      userHistory: null,
      launchRequired: false,
      userAuthenticated: false,
      superAuthenticated: false,
      excludeMobileVisitor: false,
    },
    navSelection: {
      admin: 'uploads',
      guide: 'introduction',
      dashboard: 'guide',
      leadActions: 'compareRecords',
      uploadReport: '',
      mortgageActions: '',
      databaseActions: '',
      adminRepository: '',
    },
    theme: 'light',
    dashPerspective: 'team',
    dashMemberFullName: '',
    pageSelection: '',
    runningSweep: false,
    appLoaded: false,
    viewingLeadActions: false,
    viewingUploadWindow: false,
    leadsFilteredBoolean: false,
    viewingMortgageActions: false,
    loggedOut: false,
    leadStatusFilter: 'Awaiting Action',
  },
  status: 'idle',
  error: null
}

export const sessionDataSlice = createSlice({
  name: 'sessionData',
  initialState,
  reducers: {
    setLeadsFilteredBoolean(state, action) {
      state.data.leadsFilteredBoolean = action.payload
    },
    setAwaitingInitialSweep(state, action) {
      state.data.fileUploadSearch.awaitingInitialSweep = action.payload
    },
    incFileUploadMortgagesAdded(state, action) { 
      if (action.payload === 0) {
        state.data.fileUploadSearch.mortgagesAdded = action.payload
      } else {
        state.data.fileUploadSearch.mortgagesAdded++
      }
    },
    incFileUplodDuplicateMortgages(state, action) { 
      if (action.payload === 0) {
        state.data.fileUploadSearch.duplicateMortgages = action.payload
      } else {
        state.data.fileUploadSearch.duplicateMortgages++
      }
    },
    incFileUplodErrors(state, action) { 
      if (action.payload === 0) {
        state.data.fileUploadSearch.errors = action.payload
      } else {
        state.data.fileUploadSearch.errors++
      }
    },
    setPropertySearchSaveEnabled(state, action) { state.data.propertySearch.saveEnabled = action.payload },
    setCurrentUserActionsRole(state, action) { state.data.currentUserActionsRole = action.payload },
    setExcludeMobileVisitor(state, action) { state.data.auth.excludeMobileVisitor = action.payload },
    setShowLeadActionsModal(state, action) { state.data.modalDisplays.leadActions = action.payload },
    setRepositoryPageSize(state, action) { state.data.repositoryPageSize = action.payload },
    setSuperAuthenticated(state, action) { state.data.auth.superAuthenticated = action.payload },
    setUserAuthenticated(state, action) { state.data.auth.userAuthenticated = action.payload },
    setShowWelcomeModal(state, action) { state.data.modalDisplays.welcome = action.payload },
    setLaunchRequired(state, action) { state.data.auth.launchRequired = action.payload },
    setRepositoryPage(state, action) { state.data.repositoryPage = action.payload },
    setIPAcquired(state, action) { state.data.auth.ipAcquired = action.payload },
    setAppError(state, action) { state.data.auth.appError = action.payload },
    setLoginFailed(state, action) { state.data.auth.loginFailed = action.payload },
    setIsLoggedOut(state, action) { state.data.loggedOut = action.payload },
    setIPError(state, action) { state.data.auth.ipError = action.payload },
    setDashPerspective(state, action) { state.data.dashPerspective = action.payload },
    setDashUserFullName(state, action) { state.data.dashMemberFullName = action.payload },
    setViewingLeadActions(state, action) { state.data.viewingLeadActions = action.payload },
    setViewingMortgageActions(state, action) { state.data.viewingMortgageActions = action.payload },
    setViewingUploadWindow(state, action) { state.data.viewingUploadWindow = action.payload },
    setShowMortgageActionsModal(state, action) { state.data.modalDisplays.mortgageActions = action.payload },
    setMortgageActionNavMenuSelection(state, action) { state.data.navSelection.mortgageActions = action.payload },
    setAdminNavSelection(state, action) { state.data.navSelection.admin = action.payload },
    setPageSelection(state, action) { state.data.pageSelection = action.payload },
    setNavSelection(state, action) { state.data.navSelection.dashboard = action.payload },
    setAppLoaded(state, action) {state.data.appLoaded = action.payload},
    setRunningSweep(state, action) {state.data.runningSweep = action.payload},
    setUploadReportNavMenuSelection(state, action) { state.data.navSelection.uploadReport = action.payload },
    setGuideNavSelection(state, action) { state.data.navSelection.guide = action.payload },
    setLeadActionNavMenuSelection(state, action) { state.data.navSelection.leadActions = action.payload },
    setDatabaseActionsNavMenuSelection(state, action) { state.data.navSelection.databaseActions = action.payload },
    setAdminRepositoryNavMenuSelection(state, action) { state.data.navSelection.adminRepository = action.payload },
    setLeadStatusFilter(state, action) { state.data.leadStatusFilter = action.payload },
  },
  extraReducers: (builder) => {
    builder
    .addMatcher(apiSlice.endpoints.loginReturningUser.matchFulfilled, (state, {payload}) => {
      if (payload.message.includes('successful')) {
        state.data.sessionDateParsed = Date.parse(new Date())
        if (payload.data.userInfo.role === 'super') {
          state.data.auth.superAuthenticated = true
        } else {
          // state.data.modalDisplays.welcome = true
        }
        state.data.auth.userAuthenticated = true
      }
    })
    .addMatcher(apiSlice.endpoints.establishRequestCredentials.matchFulfilled, (state, {payload}) => {
      if (payload.data) {
        state.data.auth.userHistory = payload.data.userHistory
      }
    })
    .addMatcher(apiSlice.endpoints.initialLoad.matchFulfilled, (state, {payload}) => {
      if (payload.data) {
        state.data.currentUserActionsRole = payload.data.currentUserActionsRole
        if (payload.data.missingUser) {
          state.data.appLoaded = false
        } else {
          state.data.appLoaded = true
        }
      }
    })
    .addMatcher(apiSlice.endpoints.checkForMortgageDuplicates.matchFulfilled, (state, {payload}) => {
      state.data.duplicates = payload.data.duplicates
    })
  }
})

export const { setAwaitingInitialSweep, incFileUplodErrors, setLeadStatusFilter, setShowWelcomeModal, setCurrentUserActionsRole, setRepositoryPageSize, setRepositoryPage, setPropertySearchSaveEnabled, setLaunchRequired, setUserAuthenticated, setSuperAuthenticated, setIPError, setAppError, setLoginFailed, setIPAcquired, setDashPerspective, setDashUserFullName, setAdminNavSelection, setPageSelection, setNavSelection, setAppLoaded, setRunningSweep, setGuideNavSelection, setLeadActionNavMenuSelection, setMortgageActionNavMenuSelection, setUploadReportNavMenuSelection, setDatabaseActionsNavMenuSelection, setAdminRepositoryNavMenuSelection, setExcludeMobileVisitor, setExistingInitialSweeps, setRejectionsAttomDataExpected, setRejectionsCoreLogicDataExpected, setRejectionsAttomAndCoreLogicDataExpected, setRejectionsAttomDataNew, setRejectionsCoreLogicDataNew, setRejectionsAttomAndCoreLogicDataNew, setViewingLeadActions, setViewingMortgageActions, setViewingUploadWindow, setShowLeadActionsModal, setShowMortgageActionsModal, incFileUploadMortgagesAdded, incFileUplodDuplicateMortgages, setIsLoggedOut, setLeadsFilteredBoolean } = sessionDataSlice.actions

export default sessionDataSlice.reducer

export const selectTheme = state => state.sessionData.data.theme
export const selectIPError = state => state.sessionData.data.auth.setIPError
export const selectAppError = state => state.sessionData.data.auth.appError
export const selectLoggedOut = state => state.sessionData.data.loggedOut
export const selectAppLoaded = state => state.sessionData.data.appLoaded
export const selectIPAcquired = state => state.sessionData.data.auth.ipAcquired
export const selectUserHistory = state => state.sessionData.data.auth.userHistory
export const selectLoginFailed = state => state.sessionData.data.auth.loginFailed
export const selectRunningSweep = state => state.sessionData.data.runningSweep
export const selectNavSelection = state => state.sessionData.data.navSelection.dashboard
export const selectPageSelection = state => state.sessionData.data.pageSelection
export const selectLaunchRequired = state => state.sessionData.data.auth.launchRequired
export const selectRepositoryPage = state => state.sessionData.data.repositoryPage
export const selectDashPerspective = state => state.sessionData.data.dashPerspective
export const selectDashUserFullName = state => state.sessionData.data.dashMemberFullName
export const selectShowWelcomeModal = state => state.sessionData.data.modalDisplays.welcome
export const selectLeadStatusFilter = state => state.sessionData.data.leadStatusFilter
export const selectFileUploadErrors = state => state.sessionData.data.fileUploadSearch.errors
export const selectUserAuthenticated = state => state.sessionData.data.auth.userAuthenticated
export const selectSessionDateParsed = state => state.sessionData.data.sessionDateParsed
export const selectGuideNavSelection = state => state.sessionData.data.navSelection.guide
export const selectAdminNavSelection = state => state.sessionData.data.navSelection.admin
export const selectViewingLeadActions = state => state.sessionData.data.viewingLeadActions
export const selectRepositoryPageSize = state => state.sessionData.data.repositoryPageSize
export const selectSuperAuthenticated = state => state.sessionData.data.auth.superAuthenticated
export const selectViewingUploadWindow = state => state.sessionData.data.viewingUploadWindow
export const selectLeadsFilteredBoolean = state => state.sessionData.data.leadsFilteredBoolean
export const selectAwaitingInitialSweep = state => state.sessionData.data.fileUploadSearch.awaitingInitialSweep
export const selectExcludeMobileVisitor = state => state.sessionData.data.auth.excludeMobileVisitor
export const selectShowLeadActionsModal = state => state.sessionData.data.modalDisplays.leadActions
export const selectViewingMortgageActions = state => state.sessionData.data.viewingMortgageActions
export const selectDuplicateCheckResponse = state => state.sessionData.data.duplicates
export const selectCurrentUserActionsRole = state => state.sessionData.data.currentUserActionsRole
export const selectShowMortgagectionsModal = state => state.sessionData.data.modalDisplays.mortgageActions
export const selectLeadActionsNavSelection = state => state.sessionData.data.navSelection.leadActions
export const selectUploadReportNavSelection = state => state.sessionData.data.navSelection.uploadReport
export const selectFileUploadMortgagesAdded = state => state.sessionData.data.fileUploadSearch.mortgagesAdded
export const selectPropertySearchSaveEnabled = state => state.sessionData.data.propertySearch.saveEnabled
export const selectAdminRepositoryNavSelection = state => state.sessionData.data.propertySearch.adminRepository
export const selectDatabaseActionsNavSelection = state => state.sessionData.data.navSelection.databaseActions
export const selectMortgageActionsNavSelection = state => state.sessionData.data.navSelection.mortgageActions
export const selectFileUploadDuplicateMortgages = state => state.sessionData.data.fileUploadSearch.duplicateMortgages